var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "js_5968292 1",
    clipPath: "url(#clip0_937_20561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H116V116H0V0Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.9187 90.6263C80.2553 94.4414 83.2953 97.2456 88.6718 97.2456C93.1883 97.2456 96.0736 94.9881 96.0736 91.869C96.0736 88.1312 93.1093 86.8074 88.1378 84.6328L85.4127 83.4635C77.5467 80.1125 72.3213 75.9143 72.3213 67.0394C72.3213 58.8641 78.5504 52.6406 88.2851 52.6406C95.2156 52.6406 100.198 55.0526 103.789 61.3683L95.3004 66.8185C93.4315 63.4674 91.4153 62.1472 88.2851 62.1472C85.0924 62.1472 83.0687 64.1727 83.0687 66.8185C83.0687 70.0887 85.0942 71.4125 89.7709 73.4379L92.496 74.6052C101.758 78.5768 106.987 82.6257 106.987 91.729C106.987 101.543 99.2772 106.92 88.9238 106.92C78.8005 106.92 72.2603 102.095 69.0601 95.7725L77.9187 90.6263ZM39.4122 91.5709C41.1245 94.6091 42.6824 97.1776 46.4274 97.1776C50.0087 97.1776 52.268 95.7763 52.268 90.3282V53.2632H63.1684V90.4752C63.1684 101.762 56.5509 106.899 46.8914 106.899C38.1638 106.899 33.1096 102.383 30.5391 96.9427L39.4122 91.5709Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_20561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.1fbc9d8f3cfacc720afbf8e2577703c7.svg";
export { ForwardRef as ReactComponent };